export default {
  namespaced: true,

  state: {
    dirCache: {},
  },

  mutations: {
    SET_DIR_ENTRIES(state, { key, entries }) {
      state.dirCache = { ...state.dirCache, [key]: entries };
    },
    CLEAR_DIR_CACHE(state) {
      state.dirCache = {};
    },
  },

  actions: {
    cacheDir({ commit }, { key, entries }) {
      commit("SET_DIR_ENTRIES", { key, entries });
    },
    clearDirCache({ commit }) {
      commit("CLEAR_DIR_CACHE");
    },
  },

  getters: {
    getDirEntries: (state) => (key) => state.dirCache[key] || null,
  },
};
